module.exports = __webpack_public_path__ + "static/media/rsmZAdark.681ed7de.svg";